// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCoZLbcUeUFH_WnrrfGhKSQHD6azbD1gFU",
  authDomain: "qubright-d5eae.firebaseapp.com",
  projectId: "qubright-d5eae",
  storageBucket: "qubright-d5eae.firebasestorage.app",
  messagingSenderId: "1081615216032",
  appId: "1:1081615216032:web:068bb254971bc33d8048c5",
  measurementId: "G-K7KGJ2SYJF"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);

export { app, analytics, db };
